<div
  #panel
  *ngIf="visible"
  class="debug-state-panel"
  [class.collapsed]="collapsed"
>
  <div
    class="debug-state-header"
    (pointerdown)="onHeaderPointerDown($event)"
    (dblclick)="toggleCollapse()"
  >
    <span class="debug-state-grip" aria-hidden="true">⠿</span>
    <span class="debug-state-title">{{ title }}</span>
    <span class="debug-state-actions">
      <button
        type="button"
        class="debug-state-btn"
        title="Copy JSON"
        (click)="copyState($event)"
      >
        ⧉
      </button>
      <button
        type="button"
        class="debug-state-btn"
        [title]="collapsed ? 'Expand' : 'Collapse'"
        (click)="toggleCollapse()"
      >
        {{ collapsed ? "▲" : "▼" }}
      </button>
    </span>
  </div>
  <pre *ngIf="!collapsed" class="debug-state-body">{{ rendered }}</pre>
</div>
